import { useEffect, useState } from "react";
import { Route } from "react-router-dom"
//---------------------------------------------------------------------
import UserInfo from "src/components/common/userInfo";
import likeimg from "src/img/community/like.png";
import likedimg from "src/img/community/liked.png";
//import dislikeimg from "src/img/community/dislike.png";
//import dislikedimg from "src/img/community/disliked.png";
import { isDevMode, myAxios, MyFormData, objAscSort } from "src/components/common/functions";
import { useMyStore } from "src/components/main/mainStore";
import CommunityForm from "./communityForm";
import MainReplyForm from "./mainReplyForm";
//---------------------------------------------------------------------
export default function Detail({
    closeIt, 
    path1,
    path2, 
    community, 
    history, 
    setRawData, 
    deleteUser, 
    editUser
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const [photos, setPhotos] = useState([]);
    const [reply, setReply] = useState();
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        setPhotos([]);
        const getData = async () => {
            const formData = new MyFormData();
            formData.append("fileId", community.picArrayId);
            //---------------------------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("common/getJSONData.php", formData);
            if(!isMounted) return;
            setShowLoader(false);
            if(!res) return;
            //---------------------------------------------------------------------
            setPhotos(res.data|| []);
        }
        if(path2 && path2 !== "Add") getData();
        return () => {
            isMounted = false;
            setShowLoader(false);
        }
    }, [community, setPhotos, path2, setShowLoader])
    return(
        <>
    <div className = "border" style = {{borderRadius: "6px"}}>
        <div className = "table-responsive-xl">
            <table className = "table noTopBorder">
                <tbody>
                    <tr>
                        <td style = {{whiteSpace: "pre-wrap", background: "rgba(0,212,255,0.2)", borderRadius: "6px 6px 0 0"}}>
                            {community.body}
                            {photos.length?<div className = "mt-4">{photos.map((photo, i) => 
                            <img
                                key = {i}
                                style = {{maxWidth: "100%"}}
                                className = "my-3"
                                src = {photo} 
                                alt = ""
                            />)}</div>:null}
                            <div className = "m-3 text-right">
                                {community.likeArray?.split(", ").includes(user.email)?
                                <img src = {likedimg} width = {30} alt = "" className = "pointer mr-3" onClick = {async () => {
                                    const formData = new MyFormData();
                                    formData.append("communityHashKey", community.communityHashKey);
                                    //---------------------------------------------------------------------
                                    setShowLoader(true);
                                    const res = await myAxios("community/like.php", formData);
                                    setShowLoader(false);
                                    if(!res) return;
                                    //---------------------------------------------------------------------
                                    const distinctiveData = res.data.filter(d => !d.parentHashKey).map(d => ({...d, reply: res.data.filter(dd => d.communityHashKey === dd.parentHashKey)}));
                                    setRawData(distinctiveData);
                                }}/>
                                :
                                <img src = {likeimg} width = {30} alt = "" className = "pointer mr-3" onClick = {async () => {
                                    const formData = new MyFormData();
                                    formData.append("communityHashKey", community.communityHashKey);
                                    //---------------------------------------------------------------------
                                    setShowLoader(true);
                                    const res = await myAxios("community/like.php", formData);
                                    setShowLoader(false);
                                    if(!res) return;
                                    //---------------------------------------------------------------------
                                    const distinctiveData = res.data.filter(d => !d.parentHashKey).map(d => ({...d, reply: res.data.filter(dd => d.communityHashKey === dd.parentHashKey)}));
                                    setRawData(distinctiveData);
                                }}/>}
                                {community.likeArray?community.likeArray.split(", ").length:0}
                            </div>
                        </td>
                    </tr>
                    {community.reply.sort((a, b) => objAscSort(a, b, "dateCreated")).map((r, ri) => <tr key = {ri}>
                        <td style = {{whiteSpace: "pre-wrap"}}>
                            <UserInfo 
                                name = {r.userName}
                                email = {r.email}
                            />
                            {r.replyTo?<> to <UserInfo 
                                name = {r.userName2}
                                email = {r.replyTo}
                            /></>:null}
                            &nbsp;&nbsp;:&nbsp;&nbsp;
                            {r.body}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            {r.likeArray?.split(", ").includes(user.email)?
                            <img src = {likedimg} width = {30} alt = "" className = "pointer mr-3" onClick = {async () => {
                                const formData = new MyFormData();
                                formData.append("communityHashKey", r.communityHashKey);
                                //---------------------------------------------------------------------
                                setShowLoader(true);
                                const res = await myAxios("community/like.php", formData);
                                setShowLoader(false);
                                if(!res) return;
                                //---------------------------------------------------------------------
                                const distinctiveData = res.data.filter(d => !d.parentHashKey).map(d => ({...d, reply: res.data.filter(dd => d.communityHashKey === dd.parentHashKey)}));
                                setRawData(distinctiveData);
                            }}/>:
                            <img src = {likeimg} width = {30} alt = "" className = "pointer mr-3" onClick = {async () => {
                                const formData = new MyFormData();
                                formData.append("communityHashKey", r.communityHashKey);
                                //---------------------------------------------------------------------
                                setShowLoader(true);
                                const res = await myAxios("community/like.php", formData);
                                setShowLoader(false);
                                if(!res) return;
                                //---------------------------------------------------------------------
                                const distinctiveData = res.data.filter(d => !d.parentHashKey).map(d => ({...d, reply: res.data.filter(dd => d.communityHashKey === dd.parentHashKey)}));
                                setRawData(distinctiveData);
                            }}/>}
                             {r.likeArray?r.likeArray.split(", ").length:0}
                            <span className = "ml-5 btn btn-warning" onClick = {() => {
                                history.push(`/${path1}/${community.communityHashKey}/${r.email}/Add`);
                            }}>Reply</span>
                            <Route exact path = {`/${path1}/${path2}/${r.email}/Add`}  children = {
                                <MainReplyForm
                                    keyword = "Reply" 
                                    handleSubmit = {async e => {
                                        const formData = new MyFormData(e.currentTarget);
                                        formData.append("parentHashKey", r.parentHashKey);
                                        formData.append("replyTo", r.email);
                                        //---------------------------------------------------------------------
                                        setShowLoader(true);
                                        const res = await myAxios("community/createCommunity.php", formData);
                                        setShowLoader(false);
                                        if(!res) return;
                                        //---------------------------------------------------------------------
                                        const distinctiveData = res.data.filter(d => !d.parentHashKey).map(d => ({...d, reply: res.data.filter(dd => d.communityHashKey === dd.parentHashKey)}));
                                        setRawData(distinctiveData);
                                        closeIt();
                                    }}
                                    closeIt = {closeIt}
                                />
                            }/>
                            {r.email === user.email?<>
                            <span className = "ml-3 btn btn-primary" onClick = {() => {
                                history.push(`/${path1}/${community.communityHashKey}/${r.communityHashKey}/Edit`);
                            }}>Edit</span>
                            <Route exact path = {`/${path1}/${path2}/${r.communityHashKey}/Edit`}  children = {
                                <MainReplyForm
                                    keyword = "Edit" 
                                    handleSubmit = {async e => {
                                        const formData = new MyFormData(e.currentTarget);
                                        formData.append("communityHashKey", r.communityHashKey);
                                        //---------------------------------------------------------------------
                                        setShowLoader(true);
                                        const res = await myAxios("community/updateReply.php", formData);
                                        setShowLoader(false);
                                        if(!res) return;
                                        //---------------------------------------------------------------------
                                        const distinctiveData = res.data.filter(d => !d.parentHashKey).map(d => ({...d, reply: res.data.filter(dd => d.communityHashKey === dd.parentHashKey)}));
                                        setRawData(distinctiveData);
                                        closeIt();
                                    }}
                                    closeIt = {closeIt}
                                    body = {r.body}
                                />
                            }/>
                            <span className = "ml-3 btn btn-danger" onClick = {async e => {
                                if(!window.confirm("Are you sure to delete this post?")) return;
                                const formData = new MyFormData();
                                formData.append("communityHashKey", r.communityHashKey);
                                formData.append("picArrayId", r.picArrayId);
                                //---------------------------------------------------------------------
                                setShowLoader(true);
                                const res = await myAxios("community/deleteCommunity.php", formData);
                                setShowLoader(false);
                                if(!res) return;
                                //---------------------------------------------------------------------
                                const distinctiveData = res.data.filter(d => !d.parentHashKey).map(d => ({...d, reply: res.data.filter(dd => d.communityHashKey === dd.parentHashKey)}));
                                setRawData(distinctiveData);
                            }}>Delete</span>
                            </>:null}
                        </td>
                    </tr>)}
                </tbody>
            </table>
        </div>
        {community.email === user.email?
        <div className = "m-3 text-right">
            <span className = "btn btn-primary m-3" onClick = {() => {
                history.push(`/${path1}/${community.communityHashKey}/Edit`);
            }}>Edit</span>
            <span className = "btn btn-danger m-3" onClick = {deleteUser} id = {community.communityHashKey} picid = {community.picArrayId}>Delete</span>
        </div>:null}
        <div className = "m-3 font-weight-bold">Comment</div>
        <div className = "m-3 text-right">
            <textarea className = "form-control" value = {reply} onChange = {e => setReply(e.currentTarget.value)}/>
            <span className = "btn btn-warning m-3" onClick = {async e => {
                e.preventDefault();
                if(!reply){
                    window.alert("Put something to reply.");
                    return;
                }
                const formData = new MyFormData();
                formData.append("parentHashKey", community.communityHashKey);
                formData.append("body", reply);
                //---------------------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios("community/createCommunity.php", formData);
                setShowLoader(false);
                if(!res) return;
                //---------------------------------------------------------------------
                const distinctiveData = res.data.filter(d => !d.parentHashKey).map(d => ({...d, reply: res.data.filter(dd => d.communityHashKey === dd.parentHashKey)}));
                setRawData(distinctiveData);
                setReply("");
            }}>Reply</span>
        </div>
    </div>
    <Route exact path = {`/${path1}/${path2}/Edit`}  children = {
        <CommunityForm
            keyword = "Edit" 
            handleSubmit = {editUser}
            photos = {photos}
            closeIt = {closeIt}
            
            {...community}
        />
    }/>
    </>
    )
}